<template>
    <div>
        <b-button title="Ekle" variant="primary" @click="openModal(true,'add')">Yeni Ekle </b-button>

       <b-table-simple hover responsive>
            <b-thead>
                <b-th> Bölge </b-th>
                <b-th> Sinyal </b-th>
                <b-th> Sorumlu </b-th>
                <b-th> İşlemler </b-th>
            </b-thead>
            <b-tbody>
                <b-tr>
                    <b-td> E401 </b-td>
                    <b-td> Alarm Sistemi Çözüldü </b-td>
                    <b-td> Panel / Receiver</b-td>
                    <b-td> 
                        <b-button size="sm" title="Düzenle" variant="success" @click="openModal(true,'edit')"> <b-icon icon="pen-fill" aria-hidden="true"></b-icon> </b-button>
                        <b-button size="sm" title="Sil" variant="danger" @click="openModal(true,'delete')"> <b-icon icon="trash" aria-hidden="true"></b-icon> </b-button>

                    </b-td>

                </b-tr>
                <b-tr>
                    <b-td> E401 </b-td>
                    <b-td> Alarm Sistemi Çözüldü </b-td>
                    <b-td> Panel / Receiver</b-td>
                        <b-td> 
                        <b-button size="sm" title="Düzenle" variant="success" > <b-icon icon="pen-fill" aria-hidden="true" @click="openModal(true,'edit')"></b-icon> </b-button>
                        <b-button size="sm" title="Sil" variant="danger" > <b-icon icon="trash" aria-hidden="true" @click="openModal(true,'delete')"></b-icon> </b-button>
                    </b-td>
                </b-tr>
                    <b-tr>
                    <b-td> E401 </b-td>
                    <b-td> Alarm Sistemi Çözüldü </b-td>
                    <b-td> Panel / Receiver</b-td>
                    <b-td> 
                        <b-button size="sm" title="Düzenle" variant="success" @click="openModal(true,'edit')"> <b-icon icon="pen-fill" aria-hidden="true"></b-icon> </b-button>
                        <b-button size="sm" title="Sil" variant="danger" @click="openModal(true,'delete')"> <b-icon icon="trash" aria-hidden="true"></b-icon> </b-button>
                    </b-td>

                </b-tr>
                <b-tr>
                    <b-td> E401 </b-td>
                    <b-td> Alarm Sistemi Çözüldü </b-td>
                    <b-td> Panel / Receiver</b-td>
                        <b-td> 
                        <b-button size="sm" title="Düzenle" variant="success" > <b-icon icon="pen-fill" aria-hidden="true" @click="openModal(true,'edit')"></b-icon> </b-button>
                        <b-button size="sm" title="Sil" variant="danger" > <b-icon icon="trash" aria-hidden="true" @click="openModal(true,'delete')"></b-icon> </b-button>
                    </b-td>
                </b-tr>

                <b-tr>
                    <b-td> E401 </b-td>
                    <b-td> Alarm Sistemi Çözüldü </b-td>
                    <b-td> Panel / Receiver</b-td>
                    <b-td> 
                        <b-button size="sm" title="Düzenle" variant="success" @click="openModal(true,'edit')"> <b-icon icon="pen-fill" aria-hidden="true"></b-icon> </b-button>
                        <b-button size="sm" title="Sil" variant="danger" @click="openModal(true,'delete')"> <b-icon icon="trash" aria-hidden="true"></b-icon> </b-button>
                    </b-td>

                </b-tr>
                <b-tr>
                    <b-td> E401 </b-td>
                    <b-td> Alarm Sistemi Çözüldü </b-td>
                    <b-td> Panel / Receiver</b-td>
                        <b-td> 
                        <b-button size="sm" title="Düzenle" variant="success" > <b-icon icon="pen-fill" aria-hidden="true" @click="openModal(true,'edit')"></b-icon> </b-button>
                        <b-button size="sm" title="Sil" variant="danger" > <b-icon icon="trash" aria-hidden="true" @click="openModal(true,'delete')"></b-icon> </b-button>

                    </b-td>
                </b-tr>

                <b-tr>
                    <b-td> E401 </b-td>
                    <b-td> Alarm Sistemi Çözüldü </b-td>
                    <b-td> Panel / Receiver</b-td>
                    <b-td> 
                        <b-button size="sm" title="Düzenle" variant="success" @click="openModal(true,'edit')"> <b-icon icon="pen-fill" aria-hidden="true"></b-icon> </b-button>
                        <b-button size="sm" title="Sil" variant="danger" @click="openModal(true,'delete')"> <b-icon icon="trash" aria-hidden="true"></b-icon> </b-button>
                    </b-td>

                </b-tr>
                <b-tr>
                    <b-td> E401 </b-td>
                    <b-td> Alarm Sistemi Çözüldü </b-td>
                    <b-td> Panel / Receiver</b-td>
                        <b-td> 
                        <b-button size="sm" title="Düzenle" variant="success" > <b-icon icon="pen-fill" aria-hidden="true" @click="openModal(true,'edit')"></b-icon> </b-button>
                        <b-button size="sm" title="Sil" variant="danger" > <b-icon icon="trash" aria-hidden="true" @click="openModal(true,'delete')"></b-icon> </b-button>
                    </b-td>
                </b-tr>

                <b-tr>
                    <b-td> E401 </b-td>
                    <b-td> Alarm Sistemi Çözüldü </b-td>
                    <b-td> Panel / Receiver</b-td>
                    <b-td> 
                        <b-button size="sm" title="Düzenle" variant="success" @click="openModal(true,'edit')"> <b-icon icon="pen-fill" aria-hidden="true"></b-icon> </b-button>
                        <b-button size="sm" title="Sil" variant="danger" @click="openModal(true,'delete')"> <b-icon icon="trash" aria-hidden="true"></b-icon> </b-button>
                    </b-td>

                </b-tr>
                <b-tr>
                    <b-td> E401 </b-td>
                    <b-td> Alarm Sistemi Çözüldü </b-td>
                    <b-td> Panel / Receiver</b-td>
                        <b-td> 
                        <b-button size="sm" title="Düzenle" variant="success" > <b-icon icon="pen-fill" aria-hidden="true" @click="openModal(true,'edit')"></b-icon> </b-button>
                        <b-button size="sm" title="Sil" variant="danger" > <b-icon icon="trash" aria-hidden="true" @click="openModal(true,'delete')"></b-icon> </b-button>
                    </b-td>
                </b-tr>
            </b-tbody>

        </b-table-simple>
        <DefinationModal :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />

    </div>
</template>

<script>

    export default {
        name: "SubEvent",
        data: function(){
            return{
                modalOpen: false,
                modalProps: {},
                currentForm:"SubEvent",
                modalName: "",
                
                
            }
        },
        components:{
            'DefinationModal': () => import('./index')
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        }
        
        
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/SubEvent.vue